/**
 * @generated SignedSource<<92375642c706e14ba5289a928571f8b4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type TopicsPageFragment$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly owner: {
    readonly forumOwnerKind: ForumOwnerKind;
    readonly slug: string;
  };
  readonly slug: string;
  readonly viewerCanCreateTopic: boolean;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ForumTopicsFragment" | "SubjectSubscriptionButtonFragment">;
  readonly " $fragmentType": "TopicsPageFragment";
};
export type TopicsPageFragment$key = {
  readonly " $data"?: TopicsPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicsPageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "HOT",
      "kind": "LocalArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicsPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forumOwnerKind",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanUpdate",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_FORUM"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_FORUM\")"
    },
    {
      "alias": "viewerCanCreateTopic",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_TOPIC"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_TOPIC\")"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ForumTopicsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubjectSubscriptionButtonFragment"
    }
  ],
  "type": "Forum",
  "abstractKey": null
};
})();

(node as any).hash = "89acffe01db7f63a3d83b0d754feeda2";

export default node;
